import { Helpers } from '../../helpers';
import { IEconomicsSettingsCalculationType } from '../../interfaces/ieconomics-settings-calculation-type';
import { EconomicsSetting } from '../economics-setting';

export class EconomicsSettingsCalculationTypeBase {
  EconomicsSettingsCalculationTypeId: number;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  EconomicsSettings_EconomicsSettingsCalculationType?: Array<EconomicsSetting> | null;

  constructor(item?: IEconomicsSettingsCalculationType) {
    if (item) {

      this.EconomicsSettingsCalculationTypeId = item.EconomicsSettingsCalculationTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.EconomicsSettings_EconomicsSettingsCalculationType = Helpers.createClassArray(EconomicsSetting, item.EconomicsSettings_EconomicsSettingsCalculationType);
    }
  }
}